import React from 'react';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import { Trophy, Search } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { useToast } from '@/components/ui/use-toast';

const mockResults = [
  
];

const ResultsPage = () => {
  const { toast } = useToast();
  const showNotImplementedToast = () => {
    toast({
      title: "🚧 !",
      description: "! 🚀",
      duration: 3000,
    });
  };

  return (
    <>
      <Helmet>
        <title>Hasil Lomba - Banyumas Ultra</title>
        <meta name="description" content="Lihat hasil resmi dari semua kategori Banyumas Ultra. Cari nama Anda dan lihat pencapaian para pelari." />
      </Helmet>
      <div className="bg-background pt-24 sm:pt-32">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-center mb-16"
          >
            <Trophy className="mx-auto h-12 w-12 text-primary mb-4" />
            <h1 className="text-4xl md:text-5xl font-black text-foreground">HASIL LOMBA</h1>
            <p className="mt-4 max-w-3xl mx-auto text-lg text-muted-foreground">
              Selamat kepada semua finisher! Lihat kembali pencapaian luar biasa Anda di sini.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="max-w-4xl mx-auto"
          >
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <div className="relative flex-grow">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground" />
                <Input placeholder="Cari nama atau nomor BIB..." className="pl-10" />
              </div>
              <Button onClick={showNotImplementedToast} className="w-full sm:w-auto">Cari</Button>
            </div>

            <div className="bg-card border border-border rounded-lg overflow-hidden">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead className="w-[80px]">Peringkat</TableHead>
                    <TableHead>Nama</TableHead>
                    <TableHead>Kategori</TableHead>
                    <TableHead>Waktu</TableHead>
                    <TableHead className="text-right">Negara</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {mockResults.map((result) => (
                    <TableRow key={`${result.category}-${result.rank}`}>
                      <TableCell className="font-bold text-primary">{result.rank}</TableCell>
                      <TableCell className="font-medium">{result.name}</TableCell>
                      <TableCell>{result.category}</TableCell>
                      <TableCell>{result.time}</TableCell>
                      <TableCell className="text-right">{result.country}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
            <p className="text-center text-muted-foreground mt-4 text-sm">
              Menampilkan hasil sementara. Hasil resmi akan diperbarui.
            </p>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default ResultsPage;